
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 8a4 4 0 100-8 4 4 0 000 8zm2.8 1h-.522a5.446 5.446 0 01-4.556 0H4.2A4.201 4.201 0 000 13.2v1.3A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5v-1.3C14 10.881 12.119 9 9.8 9zm10.094-4.013l-.869-.878a.37.37 0 00-.525-.003l-3.275 3.25-1.422-1.431a.37.37 0 00-.525-.003l-.878.872a.37.37 0 00-.003.525L14.95 9.89a.37.37 0 00.525.003l4.416-4.381a.373.373 0 00.003-.526z","fill":"currentColor"}})])
          )
        }
      }
    